import {Component} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {AuthorizationService} from '../../shared/authorization.service';
import {KeyValue} from '../../shared/key-value';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'help',
  templateUrl: 'help.component.html',
  styleUrls: ['help.component.css']
})
export class HelpComponent {
  interfacePath: string;
  side1:any;
  side_pop: any;
  select_pop: string;
  interfaceManualPath: string;
  decisionPath: string;
  role: string = '';
  constructor(private router: Router, private _tokenService: AngularTokenService,
  public authService: AuthorizationService, private KeyValueService: KeyValue) {
  this.interfacePath = KeyValue.interfaceManualPdfPath;
  this.interfaceManualPath = KeyValue.interfacePath;
  this.decisionPath = KeyValue.decisionManualPdfPath;
  this.side_pop=false;
  this.select_pop='';
  this.side1=false;
  }

  ngOnInit() {
    // this.role = this._tokenService.currentUserData.nickname.toLowerCase()
    this.role = this.authService.getCRole().toLowerCase();
  }

  callMePopupShow(str): void{
    this.select_pop = str;
    this.side1=true;
  }
  getSelectPop(str): any{
     let csss = str === this.select_pop ? {'active_popup':true, 'inactive_popup':false} : {'active_popup':false, inactive_popup: true}
     return csss
  }
  getSelectClose(str): any{
   this.side1=false;
  }
}
